import serverClient from '../api/ServerClient';

const ACCOUNTS_KEY = 'xpenso_accounts';

function storeAccountsInCache(accounts) {
    const acc = accounts.map((item) => ({
        id: item.id,
        name: item.name,
    }));
    localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(acc));
}

function getAccountsFromCache() {
    return JSON.parse(localStorage.getItem(ACCOUNTS_KEY));
}

async function getAccounts() {
    const cachedAccounts = getAccountsFromCache();
    if (Array.isArray(cachedAccounts) && cachedAccounts.length > 0) {
        return cachedAccounts;
    }
    const response = await serverClient.get('/api/user/accounts');
    const accounts = response?.data?.accounts || [];
    storeAccountsInCache(accounts);
    return accounts;
}

export { storeAccountsInCache, getAccountsFromCache, getAccounts };
